<template>
  <div class="container">
    <div>
      <div class="title-box">
        <div style="display: inline-block;margin-right: 10px">
          <YearSelectGroup @selected="selectedYear" class="yearSelect"/>
          <el-button size="mini" @click="changeBtn" style="margin-left: 20px"><i class="el-icon-sort"></i></el-button>
          <el-button slot="reference" size="mini" type="success" @click="exportSaveXlsx" :disabled="loadingBtn" icon="el-icon-download">{{
              loadingBtn === true ? '导出中...' : btnTypeText||'导出' }}
          </el-button>
        </div>
        <div style="font-size: 20px;font-weight: bold">{{
            query.year
          }}年度新客开拓实时检测表
          <span v-if="last_page>0&&query.page!==last_page">({{ 100 * query.page / last_page }} %)</span>
        </div>
        <div><span class="change-icon" @click="iconBtn"><i
            :class="[loading?'el-icon-loading':'el-icon-refresh']"></i></span><span>数据最后更新时间：{{ refreshTime }}</span>
        </div>
      </div>
    </div>

    <!-- 表格部分 -->
    <div class="tableCon default-table" v-show="!tableType">
      <u-table
          ref="plTable"
          :data="dataList"
          :height="height"
          use-virtual
          v-loading="loading"
          :row-height="30"
          :summary-method="summaryMethod"
          show-summary
          border>
        <u-table-column type="index" label="序号" width="60" align="center" fixed/>
        <u-table-column :label="`${val}月`" v-for="val in mouths" :key="val" align="center">
          <u-table-column :prop="`customer_name_${val}`" label="客户名称" width="200" align="center"
                          fixed="right" show-overflow-tooltip></u-table-column>
          <u-table-column label="累计销售额" :prop="`sales_volume_${val}`" width="120" align="center">
            <template slot-scope="scope">
              <div v-if="!scope.row[`sales_volume_${val}`]"></div>
              <div v-else>{{$utils.numberFormat(scope.row[`sales_volume_${val}`], 2)}}</div>
            </template>
          </u-table-column>
        </u-table-column>
      </u-table>
    </div>

    <div class="tableCon default-table" v-show="tableType">
      <u-table
          id="mTable"
          ref="plTable"
          :data="dataList"
          :height="height"
          use-virtual
          v-loading="loading"
          :row-height="30"
          :summary-method="summaryMethod"
          show-summary
          border>
        <u-table-column type="index" label="序号" width="60" align="center" fixed/>
        <u-table-column :label="`${val}月`" v-for="val in mouths" :key="val" :prop="`sales_volume_${val}`"
                        align="center">
          <template slot-scope="scope">
            <div v-if="!scope.row[`sales_volume_${val}`]"></div>
            <div v-else>{{$utils.numberFormat(scope.row[`sales_volume_${val}`], 2)}}</div>
          </template>
        </u-table-column>
        <u-table-column prop="customer_name" label="客户名称" width="200" align="center" fixed="right" show-overflow-tooltip></u-table-column>
      </u-table>
    </div>

  </div>
</template>

<script>
import {downloadCustomerExport, getCustomerSaleVolume} from '@/api/customerPool'
import FileSaver from 'file-saver';

export default {
  name: 'index',
  data() {
    return {
      height: 0,
      loading: false,
      query: {
        year: 2022,
        page: 1,
        per_page: 1000
      },
      tableType: true, //切换表格
      mouths: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      tableData: [],
      dataList: [],
      total: 0,
      percentage: '0',
      refreshTime: '', //更新时间
      last_page: 0,
      num: 0,
      loadingBtn: false,
      btnTypeText:'导出'
    }
  },
  methods: {
    //导出excel文件
    async exportSaveXlsx() {
      let {year}=this.query
      let isFileSaverSupported = !!new Blob;
      if (isFileSaverSupported) {
        const response = await downloadCustomerExport({year:year}).then(response => {
          return response
        })
        let title = `${year}年度新客开拓实时检测表`

        let data = response.data
        let contentType = response.headers['content-type']
        let blob = new Blob([data], {
          type: contentType
        });

        FileSaver.saveAs(blob, decodeURI(title + ".xlsx"), {autoBom: true});
        setTimeout(() => {
          this.loadingDownload = false
        }, 500)
      } else {
        this.$message.warning('浏览器不支持导出文件')
      }
    },
    init() {
      this.defaultYear()
      this.getInfo()
      this.time()
    },
    summaryMethod ({ columns, data }) {
      const means = [] // 合计
      columns.forEach((column, columnIndex) => {
        if (columnIndex === 0) {
          means.push('合计')
        } else {
          const values = data.map(item => Number(item[column.property]));
          // 合计
          if (!values.every(value => isNaN(value))) {
            means[columnIndex] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            means[columnIndex] = this.$utils.numberFormat(means[columnIndex], 2)
            means[columnIndex] = '<span style="color: red">' + means[columnIndex]
          } else {
            means[columnIndex] = '';
          }
        }
      })

      return [means]
    },
    getInfo() {
      this.loading = true
      getCustomerSaleVolume(this.query).then(res => {
        let data = res.data || {};
        let list = data.list || []
        this.total = data.total || 0
        this.last_page = data.last_page || 0
        // this.tableData= JSON.stringify(res.data, null, 4)

        list.forEach((item, index) => {
          // item['sales_volume' + item.month] = item.sales_volume
          // item['customer_name' + item.month] = item.customer_name

          let obj = {}
          obj['customer_id'] = item['customer_id']
          obj['customer_name'] = item['customer_name']
          let saleKey = `sales_volume_${item.month}`
          let customerKey = `customer_name_${item.month}`
          obj[saleKey] = item.sales_volume
          // obj[saleKey] = this.$utils.numberFormat(obj[saleKey], 2)
          obj[customerKey] = item.customer_name

          //是否已存在
          index = this.tableData.findIndex(value => value.customer_id === obj['customer_id'])
          if (index > -1) {
            this.tableData[index][saleKey] = obj[saleKey]
            this.tableData[index][customerKey] = obj[customerKey]
            // Object.assign(this.tableData[index],obj)
          } else {
            this.tableData.push(obj)
          }

        })

        if (this.query.page < this.last_page) {
          this.query.page++;
          setTimeout(() => {
            this.getInfo()
          }, 100)
        } else {
          this.dataList = this.tableData
          this.loading = false
        }
      })

    },
    time() {
      this.refreshTime = new Date().getTimeformat()
    },
    selectedYear(val) {
      this.query.year = val.year
      this.search()
    },
    defaultYear() {
      let date = new Date();
      this.query.year = date.getFullYear() + ''
    },
    //更新时间
    iconBtn() {
      this.search()
      this.time()
    },
    //分批请求数据
    batch() {
      this.query.page++;
      for (this.query.page; this.query.page <= this.last_page; this.query.page++) {
        this.getInfo()
      }
    },
    search() {
      this.query.page = 1
      this.tableData = []
      this.getInfo()
    },
    changeBtn() {
      this.tableType = !this.tableType
    }
  },
  created() {
    this.init()
  },
  mounted() {
    //"网页可见区域高："+document.body.clientHeight
    // "屏幕分辨率的高："+window.screen.height
    // "屏幕可用工作区高度："+window.screen.availHeight
    // console.log(window.screen.availHeight )
    this.height = window.screen.availHeight * 0.8
  }
}
</script>

<style scoped>
.container {
  min-width: 800px;
}

.title-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.change-icon {
  font-size: 30px;
}

::v-deep.plTableBox .el-table th > .cell {
  color: black;
  font-weight: bold;
  font-size: 14px;
}
</style>
